/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { EnContext } from './en-context';
import { EnPersonType } from './en-person-type';
import { JoinEntityDto } from './join-entity-dto';
 /**
 *
 *
 * @export
 * @interface ClientDto
 */
export interface ClientDto {

    /**
     * Unique identifier
     *
     * @type {number}
     * @memberof ClientDto
     * @example 1
     */
    id: number;

    /**
     * Creation timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof ClientDto
     * @example 2024-01-15T10:30:00.000Z
     */
    created: string;

    /**
     * Last update timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof ClientDto
     * @example 2024-06-01T08:00:00.000Z
     */
    updated: string;

    /**
     * Soft-delete timestamp — null when the record is active
     *
     * @type {string}
     * @memberof ClientDto
     */
    deleted: string | null;

    /**
     * @type {string}
     * @memberof ClientDto
     */
    companyName: string;

    /**
     * @type {string}
     * @memberof ClientDto
     */
    registeredOfficeAddress: string;

    /**
     * @type {string}
     * @memberof ClientDto
     */
    postalCode: string;

    /**
     * @type {string}
     * @memberof ClientDto
     */
    city: string;

    /**
     * @type {string}
     * @memberof ClientDto
     */
    province: string;

    /**
     * @type {string}
     * @memberof ClientDto
     */
    nation: string;

    /**
     * @type {JoinEntityDto}
     * @memberof ClientDto
     */
    place: JoinEntityDto;

    /**
     * @type {string}
     * @memberof ClientDto
     */
    telephone: string;

    /**
     * @type {string}
     * @memberof ClientDto
     */
    email: string;

    /**
     * @type {string}
     * @memberof ClientDto
     */
    vatNumber: string;

    /**
     * @type {string}
     * @memberof ClientDto
     */
    pec?: string;

    /**
     * @type {string}
     * @memberof ClientDto
     */
    poc?: string;

    /**
     * @type {string}
     * @memberof ClientDto
     */
    cuuCode?: string;

    /**
     * @type {string}
     * @memberof ClientDto
     */
    sdiCode?: string;

    /**
     * @type {EnPersonType}
     * @memberof ClientDto
     */
    type?: EnPersonType;

    /**
     * @type {EnContext}
     * @memberof ClientDto
     */
    context?: EnContext;

    /**
     * @type {string}
     * @memberof ClientDto
     */
    note?: string;
}
